import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { Link } from "react-router-dom";
import { FETCH_STOCK_SHIPMENT_LINES } from "./graphql";

const StockDetailView = ({ stock, stockCategoryId, latestQty }) => {
  const { loading, error, data } = useQuery(FETCH_STOCK_SHIPMENT_LINES, {
    variables: { stockId: stock.id },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const shipmentLines = data?.stockShipmentLines || [];

  return (
    <div className="text-sm">
      {shipmentLines.length === 0 ? (
        <div className="text-gray-500">No records found for this product.</div>
      ) : (
        <div className="whitespace-nowrap -mx-2">
          <table>
            <thead>
              <tr className="sticky top-0 z-10 backdrop-blur bg-gray-50 bg-opacity-80">
                <th>Date</th>
                <th>Type</th>
                <th>Ref</th>
                <th className=" text-right">Qty</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-y dark:border-gray-700">
                <td>-</td>
                <td></td>
                <td>Initial QTY</td>
                <td className=" text-right">{stock.initialQty}</td>
              </tr>
              {shipmentLines.map((line) => {
                const isIncomingByType =
                  line.shipment.moveType === "IN" ||
                  (line.shipment.moveType === "TRANSFER" &&
                    line.shipment.toLocationId === stockCategoryId);
                const rawQty = Number(line.qty) || 0;
                const isOutgoingNegativeQty =
                  line.shipment.moveType === "OUT" && rawQty < 0;
                const isIncoming = isIncomingByType || isOutgoingNegativeQty;
                const qty = Math.abs(rawQty);
                return (
                  <tr key={line.id} className="border-y dark:border-gray-700">
                    <td>{line.shipment?.date || "-"}</td>
                    <td>{line.shipment.moveType}</td>
                    <td>
                      <Link
                        to={`/sales/inventory/${stockCategoryId}/shipments/${line.shipment.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block"
                      >
                        [{line.shipment.refType}] {line.shipment.refId}{" "}
                        {line.shipment.refName}
                      </Link>
                    </td>
                    <td className="text-right">
                      {isIncoming ? "+" : "-"}
                      {qty}
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr className="font-semibold">
                <td colSpan={4} className="text-right">
                  Latest QTY: {latestQty}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </div>
  );
};
export default StockDetailView;
